export default "__VITE_ASSET__dIes5S57__"